import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modalRoot",
    "modal"
  ]

  connect() {
    if (this.hasModalRootTarget){
      this.modalRootTarget.focus({ preventScroll: true })
      this.modalRootTarget.addEventListener('keydown', (e) => {
        if (e.code !== 'Escape') return
        this.closeModal()
      })
    }

    this.element.addEventListener('turbo:submit-end', (e) => {
      if (e.detail.success) {
        this.closeModal()
      }
    })
  }

  closeModal(e) {
    e?.preventDefault()

    this.modalRootTargets.forEach((modalRoot) => {
      modalRoot.remove()
    })
  }
}
